import { useMemo } from "react";
import { useLocation } from "react-router-dom";

// TODO: Refactor to useSearchParams() or at least ask Khalid about it
export default function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}
